module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#c1k",
      "id": "c01k"
    }
  }, [_vm._v("The Books of the Torah")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Following is a list of the books of Written Torah, in the order in which they appear in Jewish translations. First is listed the Hebrew name of the book, then an English translation of the Hebrew name (where needed). The Hebrew names of the first five books are the first key words mentioned in each book (i.e., “In the beginning …” is the opening of Genesis.)"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("TORAH (The Law):"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Bereishith (In the beginning …) (Genesis)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Shemoth (The names …) (Exodus)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Vayiqra (And He called …) (Leviticus)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Bamidbar (In the wilderness …) (Numbers)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Devarim (The words …) (Deuteronomy)"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("NEVI’IM (The Prophets):"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Yehoshua (Joshua)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Shoftim (Judges)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Shmuel (I & II Samuel)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Melakhim (I & II Kings)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Yeshayah (Isaiah)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Yirmyah (Jeremiah)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Yechezqel (Ezekiel)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• The Twelve (treated as one book)")]), _vm._v(" "), _c('p', {
    staticClass: "txl"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/cir.jpg"
    }
  }), _vm._v(" Hoshea (Hosea)")]), _vm._v(" "), _c('p', {
    staticClass: "txl"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/cir.jpg"
    }
  }), _vm._v(" Yoel (Joel)")]), _vm._v(" "), _c('p', {
    staticClass: "txl"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/cir.jpg"
    }
  }), _vm._v(" Amos")]), _vm._v(" "), _c('p', {
    staticClass: "txl"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/cir.jpg"
    }
  }), _vm._v(" Ovadyah (Obadiah)")]), _vm._v(" "), _c('p', {
    staticClass: "txl"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/cir.jpg"
    }
  }), _vm._v(" Yonah (Jonah)")]), _vm._v(" "), _c('p', {
    staticClass: "txl"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/cir.jpg"
    }
  }), _vm._v(" Mikhah (Micah)")]), _vm._v(" "), _c('p', {
    staticClass: "txl"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/cir.jpg"
    }
  }), _vm._v(" Nachum")]), _vm._v(" "), _c('p', {
    staticClass: "txl"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/cir.jpg"
    }
  }), _vm._v(" Chavaqquq (Habbakkuk)")]), _vm._v(" "), _c('p', {
    staticClass: "txl"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/cir.jpg"
    }
  }), _vm._v(" Tzefanyah (Zephaniah)")]), _vm._v(" "), _c('p', {
    staticClass: "txl"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/cir.jpg"
    }
  }), _vm._v(" Chaggai")]), _vm._v(" "), _c('p', {
    staticClass: "txl"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/cir.jpg"
    }
  }), _vm._v(" Zekharyah (Zechariah)")]), _vm._v(" "), _c('p', {
    staticClass: "txl"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/cir.jpg"
    }
  }), _vm._v(" Malakhi"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("KETHUVIM (The Writings):"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Tehillim (Psalms)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Mishlei (Proverbs)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Iyov (Job)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Shir Ha-Shirim (Song of Songs)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Ruth")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Eikhah (Lamentations)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Qoheleth (the author’s name) (Ecclesiastes)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Esther")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Daniel")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Ezra & Nechemyah (Nehemiah) (treated as one book)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("• Divrei Ha-Yamim (The words of the days) (Chronicles)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a52ce1d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/books.vue
// module id = 69
// module chunks = 0